import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  payrollTypes: null,
  data: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PAYROLL:
      return { ...state, isLoading: true };

    case actionTypes.GET_PAYROLL_FULFILLED:
      return {
        ...state,
        isLoading: false,
        payrollTypes: action.payload.payrollTypes,
      };

    case actionTypes.GET_PAYROLL_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET:
    case actionTypes.DUPLICATE:
    case actionTypes.DELETE:
    case actionTypes.MODIFY:
    case actionTypes.ORDER:
      return { ...state, isLoading: true };

    case actionTypes.GET_FULFILLED:
    case actionTypes.DUPLICATE_FULFILLED:
    case actionTypes.MODIFY_FULFILLED:
    case actionTypes.DELETE_FULFILLED:
    case actionTypes.ORDER_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };

    case actionTypes.GET_REJECTED:
    case actionTypes.DUPLICATE_REJECTED:
    case actionTypes.MODIFY_REJECTED:
    case actionTypes.DELETE_REJECTED:
    case actionTypes.ORDER_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_STATE:
      return initialState;

    default:
      return state;
  }
}
